import * as React from 'react'

type UserFormValues = {
  login: string
  firstName: string
  lastName: string
  roleId: string
  userId?: string
}

type UsersModalMode = 'create' | 'edit'

type UsersModalProps = {
  isOpen: boolean
  mode: UsersModalMode
  initialValues?: UserFormValues
  rolesOptions: { value: string; label: string }[]
  pending?: boolean
  onCancel: () => void
  onSubmit: (values: UserFormValues) => void
}

// Simple modal wrapper – you can replace this with your project Modal/Dialog
export const Modal: React.FC<{
  isOpen: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
}> = ({ isOpen, title, onClose, children }) => {
  if (!isOpen) return null

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black/40">
      <div className="tw-w-full tw-max-w-lg tw-rounded-xl tw-bg-white tw-p-6 tw-shadow-lg">
        <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
          <h2 className="tw-text-lg tw-font-semibold">{title}</h2>
          <button
            type="button"
            className="tw-text-xl tw-leading-none tw-text-gray-500 hover:tw-text-gray-700"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  )
}
